import React, { Component } from "react";

import "./tools-header.css";

class ToolsHeader extends Component {
	render() {
		const { icon, title, subtitle, status, actions } = this.props;

		return (
			<div className="tools-header">
				{icon && <span className="tools-header__icon">{icon}</span>}
				<div className="tools-header__main">
					<div className="tools-header__title-row">
						<h2 className="tools-header__title">{title}</h2>
						{status}
					</div>
					{subtitle && <div className="tools-header__subtitle">{subtitle}</div>}
				</div>
				{actions && <div className="tools-header__actions">{actions}</div>}
			</div>
		);
	}
}

export default ToolsHeader;
